import type { EpicDevRequestLinkResult } from '@/features/project-board/types';

export class EpicLinkSteps {

  static labelsOf(result: EpicDevRequestLinkResult): string[] {
    const done = {
      request: `요청서 #${result.devRequestId} 생성`,
      'request-document': '하네스에 요청 문서 기록',
      prd: 'PRD 연결 줄 커밋',
      index: '보드에 바로 반영',
    };
    const unchanged = {
      request: `이 에픽에서 만든 요청서 #${result.devRequestId} 을 다시 씀`,
      'request-document': '요청 문서는 이미 있음',
      prd: 'PRD 는 이미 같음',
      index: '보드는 이미 같음',
    };
    return result.steps.map(
      (step) => {
        if (step.outcome === 'done') return done[step.step];
        if (step.outcome === 'unchanged') return unchanged[step.step];
        if (step.outcome === 'skipped') return '시도 안 함';
        if (step.outcome === 'deferred') return '즉시 반영 미완료 — 다시 시도하거나 specs 재색인';
        return `${step.step === 'prd' ? 'PRD 커밋' : '요청 문서 기록'} 실패 — ${step.detail ?? ''}`;
      },
    );
  }

  /** PRD 저장이 끝나도 색인·복구 예약이 실패하면 안내와 동일 작업 재시도를 유지한다. */
  static needsRecovery(result: EpicDevRequestLinkResult): boolean {
    return result.outcome === 'incomplete' || result.steps.some(
      (step) => step.outcome === 'failed' || step.outcome === 'deferred' || step.outcome === 'skipped',
    );
  }

  static linkedId(result: EpicDevRequestLinkResult, current: number | null): number | null {
    return result.steps.some(
      (step) => step.step === 'prd' && (step.outcome === 'done' || step.outcome === 'unchanged')
    ) ?
      result.devRequestId :
      current;
  }
}
